'use client';

import type { WizardCtx } from './types';
import { WelcomeStep } from './steps/WelcomeStep';
import { SignupStep } from './steps/SignupStep';
import { VerifyStep } from './steps/VerifyStep';
import { ProfileStep } from './steps/ProfileStep';
import { NotifStep } from './steps/NotifStep';
import { DoneStep } from './steps/DoneStep';

const MAP: Record<string, React.ComponentType<{ ctx: WizardCtx }>> = {
  'welcome': WelcomeStep,
  'signup':  SignupStep,
  'verify':  VerifyStep,
  'profile': ProfileStep,
  'notif':   NotifStep,
  'done':    DoneStep,
};

export function StepRouter({ ctx }: { ctx: WizardCtx }) {
  const id = ctx.steps[ctx.stepIdx].id;
  const Cmp = MAP[id];
  if (!Cmp) return null;
  return <Cmp ctx={ctx} />;
}
